import moment from 'moment';

function isHtml5DateSupported() {
    let input = document.createElement('input');
    input.setAttribute('type', 'date');

    let notADateValue = 'not-a-date';
    input.setAttribute('value', notADateValue);

    return input.value !== notADateValue;
}

function isNull(obj) {
    return obj === null || typeof obj === 'undefined';
}

class HTML5DateCoercer {
    toStr(obj) {
        if (isNull(obj)) {
            return '';
        }
        return moment(obj, ['DD.MM.YYYY'], true).format('YYYY-MM-DD');
    }

    fromStr(str) {
        if (!str) {
            return null;
        }
        return moment(str, ['YYYY-MM-DD'], true).format('DD.MM.YYYY');
    }

    isValidStr() {
        return true;
    }
}

export function getDateCoercer() {
    if (isHtml5DateSupported()) {
        return new HTML5DateCoercer();
    }
    return undefined;
}
